import React from 'react';
import { Star } from 'lucide-react';

export const renderStars = (count) => Array.from({ length: 5 }, (_, i) => (
  <Star key={i} size={12} className={i < count ? 'text-yellow-400 fill-yellow-400' : 'text-gray-300'} />
));
